import $axios from '@/axios-instance.js'

export const metaService = {
  getMetaData
}

function getMetaData () {
  return $axios.get(`${process.env.ROOT_API}/meta`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/meta.service.js